"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiCheckbox = void 0;
const icons_1 = require("client/components/icons");
const react_1 = require("react");
const React = require("react");
require("./checkbox.less");
class UiCheckbox extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClick = (event) => {
            event.stopPropagation();
            this.props.onChange();
        };
        this.renderCheckmark = (fill) => React.createElement(icons_1.CheckmarkIcon, { fill: fill });
    }
    render() {
        const { checked, fill } = this.props;
        return (React.createElement("div", { className: "ui-checkbox", onClick: this.handleClick }, checked && this.renderCheckmark(fill)));
    }
}
exports.UiCheckbox = UiCheckbox;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/checkbox/checkbox.tsx
// module id = 3627
// module chunks = 0